$(document).ready(function () {
    $(".reviews-slider").slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
        {
            breakpoint: 768,
            settings: {
            slidesToScroll: 1,
            slidesToShow: 1
            }
        }
        ]
    });
});